import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import { loadSuccess, loadFailure, loadRequest } from './actions';

export function* loadAtendimentos({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getOcorrencias&pagina=${
        payload.pagination ? payload.pagination?.current - 1 : 0
      }&tamanhoPagina=${payload.pagination ? payload.pagination?.pageSize : 5}&token=${
        state.auth.token
      }`,

      {
        filtro: payload?.filter,
        centroDistribuicao: payload?.cddAtivo,
        inscricoesEstaduais: payload?.inscricaoAtiva,
        ordenacao: payload?.sorter,
      }
    );

    yield put(
      loadSuccess(response.data.ocorrencias, {
        total: response.data.total,
        current: payload.pagination?.current || 0 + 1,
        pageSize: payload.pagination?.pageSize || 5,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
      })
    );
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar os atendimentos, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
